import styled from "styled-components"

const Bound = styled.input`
    font-family: UTM-AVO;
    ${props => props.specificStyles}
    ${props => props.extendStyles}
`

export { Bound };